import { render, staticRenderFns } from "./TWCustomerShippingmarkNormal.vue?vue&type=template&id=c08601ae&scoped=true&"
import script from "./TWCustomerShippingmarkNormal.vue?vue&type=script&lang=js&"
export * from "./TWCustomerShippingmarkNormal.vue?vue&type=script&lang=js&"
import style0 from "./TWCustomerShippingmarkNormal.vue?vue&type=style&index=0&id=c08601ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08601ae",
  null
  
)

export default component.exports